/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';
import SimpleModal from '@/shadcn/components/SimpleModal.tsx';

export default function SocialConnectModule(Component) {

    class SocialConnectModule extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                isDuplicateSocialModalVisible: false,
                isBlacklistModalVisible: false,
                isClientSocialModalVisible: false,
                isMovementRestrictedModalVisible: false
            };

            this.remoteReturnHandler = this.remoteReturnHandler.bind(this);
            this.showDuplicateSocialModal = this.showDuplicateSocialModal.bind(this);
            this.showBlacklistModal = this.showBlacklistModal.bind(this);
            this.showClientSocialModal = this.showClientSocialModal.bind(this);
            this.showMovementRestrictedModal = this.showMovementRestrictedModal.bind(this);

        }

        remoteReturnHandler(methodCallbacks) {

            if (_.isArray(methodCallbacks)) {
                methodCallbacks.map((mc) => {
                    // a little validation before we proceed
                    if (mc.path === undefined || mc.method === undefined || mc.method === '') {
                        return;
                    }

                    if (this.props.authState.credID.match(mc.method)) {
                        if (mc.callback !== undefined) {
                            this.props.authReturnHandler({
                                path: mc.path
                            }, mc.callback);
                        }
                    }

                });
            }

        }

        showMovementRestrictedModal(callbacks) {
            // error for people trying to move socials and get posting for free
            let callback = () => {
                this.setState({
                    isMovementRestrictedModalVisible: false
                });
                this.props.closeAllModals();

                if (callbacks.confirm) {
                    callbacks.confirm.apply(this, []);
                }
            };

            this.props.showUpgradeModal(callback, 'moveSocial', null, 'social_move_error');

            this.setState({
                isMovementRestrictedModalVisible: true
            });
        }

        /*
         * The social the server rejected, which is carried on the error itself.
         *
         * Three of the four callers of showDuplicateSocialModal already dig it
         * out of here, and the fourth passed component state that is null unless
         * a connect has just returned — so confirming the move threw on a record
         * that was never there. Resolved here instead, so no caller has to know
         * and none of them can get it wrong.
         *
         * The argument still wins when there is one: SocialConfig synthesises a
         * record from the auth state for the credential networks, which carries
         * fields the rejected post does not.
         */
        rejectedSocial(social) {
            let errors = (this.props.app.errors && this.props.app.errors.api) ? this.props.app.errors.api : [],
                rejected = null;

            if (social) {
                return social;
            }

            for (let i = 0; i < errors.length; ++i) {
                if (['SOCIAL_CREATE', 'SOCIAL_UPDATE'].indexOf(errors[i].type) !== -1 && errors[i].post) {
                    rejected = errors[i].post;
                }
            }

            return rejected;

        }

        showDuplicateSocialModal(passedSocial, callbacks) {

            let confirmAction = () => {
                    let constants = this.props.app.config.constants,
                        loginTypes = [constants.POST_SVC_BLUESKY],
                        social = this.rejectedSocial(passedSocial);

                    /*
                     * Resolved on confirm rather than when the modal is raised,
                     * so it reads the error that is current when the user answers.
                     * Nothing to move means the rejection has already been cleared
                     * from under us — close, and let the caller tidy up.
                     */
                    if (!social) {
                        this.props.closeAllModals();
                        this.setState({
                            isDuplicateSocialModalVisible: false
                        }, () => {
                            if (callbacks.confirm) {
                                callbacks.confirm.apply(this, [null]);
                            }
                        });

                        return;
                    }

                    social.force = true;
                    if ((social.credID === undefined || !social.credID) && loginTypes.indexOf(social.psID) === -1) {
                        // be sure to make the social active if it's not in the create case
                        if (social.activeFlag !== undefined && social.activeFlag === 0) {
                            social.activeFlag = 1;
                        }
                        this.props.updateSocial(social);
                    } else {
                        if ((social.credID !== undefined && _.isString(social.credID) && social.credID.match("REAUTH")) || (loginTypes.indexOf(social.psID) !== -1 && social.action === "UPDATE")) {
                            // be sure to make the social active if it's not in the create case
                            if (social.activeFlag !== undefined && social.activeFlag === 0) {
                                social.activeFlag = 1;
                            }
                            this.props.updateSocial(social);
                        } else {
                            this.props.createSocial(social);
                        }
                    }

    				this.props.closeAllModals();

                    this.setState({
                        isDuplicateSocialModalVisible: false
                    }, () => {
                        if (callbacks.confirm) {
                            callbacks.confirm.apply(this, [social]);
                        }
                    });
    			},
                cancelAction = () => {
                    this.props.closeAllModals();
                    this.setState({
                        isDuplicateSocialModalVisible: false
                    }, () => {
                        if (callbacks.cancel) {
                            callbacks.cancel.apply(this, [this.rejectedSocial(passedSocial)]);
                        }
                    });
                },
    			modal = (
    				<SimpleModal
    					title="Move this social?"
    					description="Someone is already using this social. Adding it here will deactivate it in all other dlvr.it accounts."
    					confirmLabel="Continue"
    					cancelLabel="Cancel"
    					onConfirm={confirmAction}
    					onCancel={cancelAction}
    					onClose={cancelAction} />
    			);

    		this.props.closeOtherModals(modal);

            this.setState({
                isDuplicateSocialModalVisible: true
            });

        }

        showBlacklistModal(callbacks) {
            // special case error for people who's socials have been blacklisted
            let callback = () => {
                this.setState({
                    isBlacklistModalVisible: false
                });
                this.props.closeAllModals();

                if (callbacks.confirm) {
                    callbacks.confirm.apply(this, []);
                }
            };

            let modal = (
                <SimpleModal
                    title="Profile suspended"
                    description="This social profile has been suspended. dlvr.it will not connect or post to this profile."
                    confirmLabel="OK"
                    cancelLabel={null}
                    onConfirm={callback}
                    onClose={callback}/>
            );

            this.props.closeOtherModals(modal);

            this.setState({
                isBlacklistModalVisible: true
            });

        }

        showClientSocialModal(callbacks) {
            let organization = "The parent account";

            if (this.props.user.detail.clientInfo !== undefined && this.props.user.detail.clientInfo.organization) {
                organization = this.props.user.detail.clientInfo.organization;
            }

            let acknowledge = () => {
                    // SocialConfig derives its modalUp gate from this on every
                    // render; left true, it silences that page's prompts for the
                    // rest of the session.
                    this.setState({
                        isClientSocialModalVisible: false
                    });
                    this.props.closeAllModals();
                    if (callbacks.confirm) {
                        callbacks.confirm.apply(this, []);
                    }
                },
                modal = (
                    <SimpleModal
                        title="Account limit reached"
                        description={`${organization} has reached the maximum number of social profiles for this account. Please contact ${organization} to resolve this issue.`}
                        confirmLabel="OK"
                        cancelLabel={null}
                        onConfirm={acknowledge}
                        onClose={acknowledge}/>
                );
            this.props.closeOtherModals(modal);

            this.setState({
                isClientSocialModalVisible: true
            });
        }

        render() {
            return (
                <Component
                    remoteReturnHandler={this.remoteReturnHandler}
                    showDuplicateSocialModal={this.showDuplicateSocialModal}
                    showBlacklistModal={this.showBlacklistModal}
                    showClientSocialModal={this.showClientSocialModal}
                    showMovementRestrictedModal={this.showMovementRestrictedModal}
                    isDuplicateSocialModalVisible={this.state.isDuplicateSocialModalVisible}
                    isBlacklistModalVisible={this.state.isBlacklistModalVisible}
                    isClientSocialModalVisible={this.state.isClientSocialModalVisible}
                    isMovementRestrictedModalVisible={this.state.isMovementRestrictedModalVisible}
                    {...this.props}/>
            );
        }
    }

    SocialConnectModule.displayName = "SocialConnectModule";
    return SocialConnectModule;
}
